export const CategoriesModalComponent: ng.IComponentOptions = {
  bindings: {
    categories: '<',
    onClose: '&',
    onSelect: '&',
  },
  templateUrl: 'categories/components/categories-modal/categories-modal.html',
};
